import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'lib-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {
  @Input() public applicationName: string;
  @Input() public workCenterName: string;
  @Input() public packagramLogoEnabled: boolean;

  @HostBinding('class')
  get themeClass(): string {
    return this.packagramLogoEnabled ? 'theme-packagram' : 'theme-customer';
  }
}
